import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { useSendCommandAsync } from '@/_core/cqrs/use';
import { createSaveAboutBoardCommand } from '../../api/commands/factory/createAboutBoardCommands';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeAboutBoardDescription extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeAboutBoardDescription';

    public constructor(public description: string) {
        super(ChangeAboutBoardDescription.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: ChangeAboutBoardDescription): Promise<boolean> => {
    return useSendCommandAsync(action, {
        createCommand: async () => await createSaveAboutBoardCommand(action),
    });
};

const reducer = (state: StorymapState, action: ChangeAboutBoardDescription): void => {
    state.aboutBoardDescription = action.description;
};

//@ts-ignore
registerMiddleware(ChangeAboutBoardDescription.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeAboutBoardDescription.ACTION_TYPE, reducer);
